import { combineEpics } from 'redux-observable';

import {
  accountAuditLogEntriesFetch,
  accountAuditLogEntryDetailsFetch,
  accountCustomRolesFetch,
  accountFetch,
  accountHighUsageFetch,
  accountLegacySubscriptionFetch,
  accountMemberSessionsFetch,
  accountMembersFetch,
  accountMembersForExportFetch,
  accountMembersSearchEpic,
  accountSearch,
  accountSearchClearance,
  accountsFetch,
  accountSubscriptionFetch,
  accountSubscriptionUsageFetch,
  cancelSubscription,
  disableMfa,
  eapSegmentsFetch,
  enterpriseTrialCampaignUpdates,
  guardianTrialCampaignUpdates,
  legacySubscriptionGraceEndUpdates,
  legacySubscriptionTrialEndUpdates,
  resendMemberInvitationEpic,
  subscribe,
  subscriptionGraceEndUpdates,
  subscriptionTrialEndUpdates,
} from './accounts';
import { type Actions } from './actions';
import { checkingAuth, signIn, signOut } from './auth';
import { postToSlack, processNotifications } from './notifications';
import {
  availablePlansFetch,
  executedPlanSet,
  launchOrderEndDateSet,
  launchOrdersFetch,
  rejectedPlanSet,
  selectedPlanRefresh,
  selectPlanGet,
} from './provisioning';
import type { AppState } from './reducer';
import { settingsPrivateFetch, trackAccountSearch, trackAccountSearchTiming } from './settings';

export default combineEpics<Actions, Actions, AppState>(
  processNotifications,
  postToSlack,
  accountsFetch,
  accountFetch,
  accountLegacySubscriptionFetch,
  accountSubscriptionFetch,
  accountSubscriptionUsageFetch,
  subscriptionTrialEndUpdates,
  subscriptionGraceEndUpdates,
  enterpriseTrialCampaignUpdates,
  guardianTrialCampaignUpdates,
  legacySubscriptionTrialEndUpdates,
  legacySubscriptionGraceEndUpdates,
  subscribe,
  cancelSubscription,
  accountMembersFetch,
  accountMembersForExportFetch,
  accountMemberSessionsFetch,
  accountCustomRolesFetch,
  accountSearch,
  accountSearchClearance,
  accountHighUsageFetch,
  accountAuditLogEntriesFetch,
  accountAuditLogEntryDetailsFetch,
  trackAccountSearch,
  trackAccountSearchTiming,
  settingsPrivateFetch,
  disableMfa,
  availablePlansFetch,
  selectPlanGet,
  selectedPlanRefresh,
  launchOrdersFetch,
  launchOrderEndDateSet,
  executedPlanSet,
  rejectedPlanSet,
  checkingAuth,
  signIn,
  signOut,
  accountMembersSearchEpic,
  resendMemberInvitationEpic,
  eapSegmentsFetch,
);
